import { ChatSchema, PaginatedChatSummariesResponse } from '../../types/chatTypes'
import { axiosClient } from '../axiosClient'

export const chatHistoryFunctions = {
  fetchChatSummaries: async (page = 1, size = 20): Promise<PaginatedChatSummariesResponse> => {
    return await axiosClient.get(`api/chat/summaries?page=${page}&size=${size}`)
  },

  searchChatSummaries: async (query: string, page = 1, size = 20): Promise<PaginatedChatSummariesResponse> => {
    return await axiosClient.get(`api/chat/summaries/search?q=${encodeURIComponent(query)}&page=${page}&size=${size}`)
  },

  fetchChatDetails: async (chatId: string): Promise<ChatSchema> => {
    return await axiosClient.get(`api/chat/chats/${chatId}`)
  },
}
